import React from 'react'
import {LocalLink} from 'i18n/LocalLink'
import {
  organizationEventAttendeeRoutes,
  useOrganizationEventRoutes,
} from 'organization/OrganizationRoutes'
import {Attendant} from 'organization/Event/Attendants/ViewAttendant/AttendantProvider'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import VisibilityIcon from '@mui/icons-material/Visibility'
import styled from 'styled-components'
import {useEventAttendants} from 'organization/Event/Attendants/EventAttendantsProvider'
import {confirmAlert} from 'react-confirm-alert'
import {useI18n} from 'i18n/I18nContext'

export const ListAttendant = (props: {attendant: Attendant; index: number}) => {
  const {t} = useI18n()
  const {attendant, index} = props
  const organizationEventRoutes = useOrganizationEventRoutes()
  const routes = organizationEventAttendeeRoutes(
    attendant,
    organizationEventRoutes,
  )

  const {remove} = useEventAttendants()

  const removeAttendand = () => {
    confirmAlert({
      message: t('org.attendees.confirmRemove'),
      buttons: [
        {
          label: t('common.yes'),
          onClick: () => {
            remove(attendant)
          },
        },
        {
          label: t('common.no'),
          onClick: () => {
            // nothing
          },
        },
      ],
    })
  }

  return (
    <tr key={index}>
      <td> {attendant.id} </td>
      <td>{attendant.attendee.first_name} </td>
      <td>{attendant.attendee.last_name}</td>
      <td>{attendant.attendee.email}</td>
      <td>{attendant.event_ticket?.name ?? '—'}</td>

      <td>
        <ActionButtons>
          <LocalLink to={routes.view}>
            <VisibilityIcon color="info" fontSize="large" />
          </LocalLink>

          <button onClick={removeAttendand}>
            <HighlightOffIcon color="warning" fontSize="large" />
          </button>
        </ActionButtons>
      </td>
    </tr>
  )
}

const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
`
